import React, { useEffect, useRef, useState } from 'react';
import Icon from '@/components/Icon';

export default function FilterChip({ label, value, options, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const current = options.find((o) => o.v === value);
  const isDefault = value === 'all';

  return (
    <div className="chip-wrap" ref={ref}>
      <button
        className={'chip' + (!isDefault ? ' is-active' : '')}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="chip__label">{label}</span>
        {!isDefault && <span className="chip__sep">:</span>}
        {!isDefault && <span className="chip__value">{current?.label.replace(/^.*?: /, '')}</span>}
        <Icon name="chevronDown" size={10} />
      </button>
      {open && (
        <div className="menu">
          {options.map((o) => (
            <button
              key={o.v}
              className={'menu__item' + (o.v === value ? ' is-active' : '')}
              onClick={() => { onChange(o.v); setOpen(false); }}
            >
              <span>{o.label}</span>
              {o.v === value && <Icon name="check" size={12} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
